import { forwardRef } from 'react';
import MuiAvatar, { AvatarProps as OriginalAvatarProps } from '@mui/material/Avatar';
import { getFullNameAbbr } from '../../../libs/utils/string';
import { styled } from '@mui/material';

export interface AvatarProps extends OriginalAvatarProps {
  fullName?: string;
}

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(function Avatar(
  { src, children, fullName, ...props },
  ref,
) {
  return (
    <MuiAvatar src={src} {...props} ref={ref}>
      {fullName ? getFullNameAbbr(fullName) : children}
    </MuiAvatar>
  );
});

export const SystemUserAvatar = forwardRef<HTMLDivElement, AvatarProps>(function SystemUserAvatar(
  { src, children, fullName, ...props },
  ref,
) {
  return <SystemUserAvatarStyled {...props} ref={ref} />;
});

const SystemUserAvatarStyled = styled(Avatar, {
  // shouldForwardProp: (prop: string) => !['src'].includes(prop),
})(({ theme, src }) => ({
  ...(src ? { backgroundColor: theme.palette.background.paper } : {}),
  outline: `2px solid ${theme.palette.success.light}`,
  lineHeight: 0,
}));

export const InternalProviderAvatar = forwardRef<HTMLDivElement, AvatarProps>(function InternalProviderAvatar(
  { src, children, fullName, ...props },
  ref,
) {
  return <InternalProviderAvatarStyled {...props} ref={ref} />;
});

const InternalProviderAvatarStyled = styled(Avatar, {
  // shouldForwardProp: (prop: string) => !['src'].includes(prop),
})(({ theme, src }) => ({
  ...(src ? { backgroundColor: theme.palette.background.paper } : {}),
  outline: `2px solid ${theme.palette.info.main}`,
  lineHeight: 0,
}));

export const ExternalProviderAvatar = forwardRef<HTMLDivElement, AvatarProps>(function ExternalProviderAvatar(
  { src, children, fullName, ...props },
  ref,
) {
  return <ExternalProviderAvatarStyled {...props} ref={ref} />;
});

const ExternalProviderAvatarStyled = styled(Avatar, {
  // shouldForwardProp: (prop: string) => !['src'].includes(prop),
})(({ theme, src }) => ({
  ...(src ? { backgroundColor: theme.palette.background.paper } : {}),
  outline: `2px solid ${theme.palette.warning.main}`,
  lineHeight: 0,
}));

export const OrganizationAvatar = forwardRef<HTMLDivElement, AvatarProps>(function OrganizationAvatar(
  { src, children, fullName, ...props },
  ref,
) {
  return <OrganizationAvatarStyled {...props} ref={ref} />;
});

const OrganizationAvatarStyled = styled(Avatar, {
  // shouldForwardProp: (prop: string) => !['src'].includes(prop),
})(({ theme, src }) => ({
  ...(src ? { backgroundColor: theme.palette.background.paper } : {}),
  // outline: `2px solid ${theme.palette.success.light}`,
  lineHeight: 0,
}));

export const LocationAvatar = forwardRef<HTMLDivElement, AvatarProps>(function LocationAvatar(
  { src, children, fullName, ...props },
  ref,
) {
  return <LocationAvatarStyled {...props} ref={ref} />;
});

const LocationAvatarStyled = styled(Avatar, {
  // shouldForwardProp: (prop: string) => !['src'].includes(prop),
})(({ theme, src }) => ({
  ...(src ? { backgroundColor: theme.palette.background.paper } : {}),
  // outline: `2px solid ${theme.palette.success.light}`,
  lineHeight: 0,
}));
